function BigLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f4f6fb] px-4">
      <div className="flex min-w-[220px] flex-col items-center gap-4 px-10 py-9">
        <div className="h-11 w-11 animate-spin rounded-full border-[3px] border-primary/20 border-t-primary" />
        <p className="text-sm font-semibold text-slate-600">Loading...</p>
      </div>
    </div>
  );
}

export default BigLoader;
